import styled from '@emotion/styled'

export const FieldName = styled.p`
  font-size: 12px;
  margin: 0;
  text-transform: capitalize;
`

export const FieldLabel = styled.p`
  font-size: 11px;
  color: #00000061;
  margin: 0;
`

export const Container = styled.div`
  display: flex;
`
